<template>
	<auth-container :page="page">
		<h2 class="mb-4">Create New Project</h2>

		<sr-project-form :item="item" :application="application" :set-options="setOptions"></sr-project-form>
	</auth-container>
</template>

<script>
	import SrProjectForm from './SrProjectForm.vue';
	export default {
		name: 'SrProjectCreate',
		components: {
			SrProjectForm
		},
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false
				},
				item: {
					applicationId: null,
					damId: null,
					projectNumber: null,
					name: null,
					status: null,
					statusNote: null,
					category: null,
					currentPhase: null,
					projectManager: null,
					expectedCompletionDate: null,
					completionSubmissionDate: null,
					awardDate: null,
					notes: null
				},
				application: null,
				setOptions: {
					statuses: [],
					categories: [],
					phases: [],
				}
			}
		},
		async created() {
			await this.get();
		},
		watch: {
			'$route': 'get'
		},
		methods: {
			async get() {
				this.page.loading = true;
				this.page.errors = [];

				try {
					const response = await this.$http.get(`srprojects/options`, this.getTokenHeader());
					this.setOptions = response.data;
				} catch (error) {
					if (this.isApiUnauthorized(error)) this.page.showLogin = true;
					else this.page.errors = this.logError(error);
				}

				if (!this.isNullOrEmpty(this.$route.query.appId)) {
					try {
						const response = await this.$http.get(`srapplications/${this.$route.query.appId}`, this.getTokenHeader());
						this.application = response.data.application;
					} catch (error) {
						if (this.isApiUnauthorized(error)) this.page.showLogin = true;
						else this.page.errors = this.logError(error);
					}
				}

				this.page.loading = false;
			}
		}
	}
</script>